module.exports = __webpack_public_path__ + "static/media/organizer_2.73435679.jpg";